import { useRef, useState } from 'react';

function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.447-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

export default function VideoDiagnostic() {
  const fileRef = useRef<HTMLInputElement>(null);
  const [preview, setPreview] = useState<string | null>(null);

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setPreview(url);
    }
  };

  return (
    <section className="w-full bg-[#EEF2F4] py-10 md:py-14">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-stretch">
          {/* Colonne Image */}
          <div className="w-full lg:w-1/2 flex items-center">
            <div className="w-full relative">
              <div className="w-full aspect-[4/3] rounded-xl overflow-hidden border border-[#FF6B4A]/20 shadow-lg shadow-[#1E3A47]/5">
                {preview ? (
                  <img
                    src={preview}
                    alt="Aperçu de votre photo"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20professional%20technician%20in%20a%20blue%20uniform%20doing%20a%20video%20call%20on%20a%20smartphone%20screen%20while%20a%20homeowner%20holds%20the%20phone%20showing%20a%20modern%20white%20PVC%20window%20with%20a%20broken%20handle%20the%20technician%20is%20pointing%20at%20the%20window%20mechanism%20on%20screen%20warm%20indoor%20lighting%20clean%20modern%20interior%20background%20professional%20service%20photography%20style%20with%20soft%20natural%20light%20warm%20tones%20of%20beige%20and%20white&width=1600&height=1200&seq=visiodiag001&orientation=landscape"
                    alt="diagnostic en visio d'une fenêtre par WhatsApp - DF PRO Strasbourg"
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
              <p className="text-xs text-[#1E3A47]/40 mt-2 text-center">
                Vous pouvez aussi directement envoyer vos photos sur WhatsApp
              </p>
            </div>
          </div>

          {/* Colonne Texte */}
          <div className="w-full lg:w-1/2 flex flex-col justify-center">
            <span className="text-[#FF6B4A] text-sm font-semibold tracking-widest uppercase mb-3">
              Notre petit plus
            </span>
            <h2 className="text-[#1E3A47] text-2xl md:text-3xl font-bold mb-4 leading-tight">
              Montrez-nous votre panne, sans attendre la visite
            </h2>
            <p className="text-[#1E3A47]/70 text-base leading-relaxed mb-6">
              Pas besoin d'attendre un rendez-vous pour un devis. Appelez-nous en visio
              (WhatsApp/FaceTime) ou envoyez-nous une photo ou une vidéo de votre fenêtre.
              Notre technicien identifie la panne, vous annonce la solution et une estimation,
              et nous intervenons avec la bonne pièce.
            </p>

            {/* 3 étapes */}
            <div className="flex flex-col gap-3 mb-6">
              <div className="flex items-start gap-3">
                <span className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-[#25D366] text-white text-sm font-bold mt-0.5">
                  1
                </span>
                <p className="text-[#1E3A47] text-sm font-medium pt-1.5">
                  Envoyez une photo/vidéo ou appelez en visio
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-[#25D366] text-white text-sm font-bold mt-0.5">
                  2
                </span>
                <p className="text-[#1E3A47] text-sm font-medium pt-1.5">
                  Diagnostic à distance
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-[#25D366] text-white text-sm font-bold mt-0.5">
                  3
                </span>
                <p className="text-[#1E3A47] text-sm font-medium pt-1.5">
                  Solution et tarif annoncés, intervention avec la bonne pièce
                </p>
              </div>
            </div>

            {/* Mention gratuite */}
            <div className="flex items-center gap-2 mb-6">
              <svg className="w-5 h-5 text-[#25D366] flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span className="text-[#1E3A47] font-semibold text-sm">
                Gratuit et sans engagement
              </span>
            </div>

            {/* Boutons */}
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://wa.me/33745883392"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-lg bg-[#25D366] text-white font-semibold text-sm hover:bg-[#1EBE5D] transition-colors whitespace-nowrap"
              >
                <WhatsAppIcon />
                Envoyer mes photos / Visio
              </a>
              <a
                href="tel:0374471036"
                className="inline-flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-lg bg-[#FF6B4A] text-white font-semibold text-sm hover:bg-[#FF6B4A]/90 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line text-base" />
                Appeler le 03 74 47 10 36
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}